import axios from "./axios";

const DashboardService = {
  fetchDashboard: async () => {
    const response = await axios.get("/dashboard");
    return response;
  },
};

export default DashboardService;
